// One product, its lots underneath.
//
// Stock is stored per lot (event_stock_allocations has a row per batch), but a
// person reads it per product: "how much of this lens did we bring, and in
// which lots". Every screen that lists allocations groups them the same way,
// through this.

import type { EventStockAllocation } from '@/types/domain';

export interface AllocationGroup {
  productId: string;
  productName: string;
  productSku: string;
  productPrice: number;
  unit: string;
  /** Earliest expiry first; undated lots last. */
  lots: EventStockAllocation[];
  qtyIn: number;
  qtySold: number;
  qtyReturnedToGudang: number;
  /** qtyIn − qtySold, never below zero per lot. */
  available: number;
}

export function groupAllocationsByProduct(allocations: ReadonlyArray<EventStockAllocation>): AllocationGroup[] {
  const map = new Map<string, AllocationGroup>();
  for (const a of allocations) {
    let g = map.get(a.productId);
    if (!g) {
      g = {
        productId: a.productId,
        productName: a.productName,
        productSku: a.productSku,
        productPrice: a.productPrice,
        unit: a.unit,
        lots: [],
        qtyIn: 0,
        qtySold: 0,
        qtyReturnedToGudang: 0,
        available: 0,
      };
      map.set(a.productId, g);
    }
    g.lots.push(a);
    g.qtyIn += a.qtyIn;
    g.qtySold += a.qtySold;
    g.qtyReturnedToGudang += a.qtyReturnedToGudang;
    g.available += Math.max(0, a.qtyIn - a.qtySold);
  }
  const groups = [...map.values()];
  for (const g of groups) {
    g.lots.sort((x, y) => (x.expiryDate ?? Infinity) - (y.expiryDate ?? Infinity) || x.lotNumber.localeCompare(y.lotNumber));
  }
  return groups.sort((a, b) => a.productName.localeCompare(b.productName));
}
